import { render, staticRenderFns } from "./totalsBarsIcon.vue?vue&type=template&id=148ba14e&"
import script from "./totalsBarsIcon.vue?vue&type=script&lang=js&"
export * from "./totalsBarsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports